module.exports = __webpack_public_path__ + "img/20210906-1630911149119306.b224308b.jpg";